import request from '../request'

export function createGzwz(data) {
    return request({
        url: '/wx/createGzwz',
        method: 'post',
        data: data
    })
}

//获取故障位置树形结构
export function getTreeQueryGzwzList(data) {
    return request({
        url: '/wx/queryGzwzTree',
        method: 'get',
        params: data
    })
}

export function deleteGzwz(id) {
    return request({
        url: '/wx/deleteGzwz?id='+id,
        method: 'get',
        params: {}
    })
}

///wx/updateGzwz
//修改
export function updateGzwz(data) {
    return request({
        url: '/wx/updateGzwz',
        method: 'post',
        data: data
    })
}

//现象
export function getTreeQueryGzxxList(data) {
    return request({
        url: '/wx/queryGzxxTree',
        method: 'get',
        params: data
    })
}

export function deleteGzxx(id) {
    return request({
        url: '/wx/deleteGzxx?id='+id,
        method: 'get',
        params: {}
    })
}

export function createGzxx(data) {
    return request({
        url: '/wx/createGzxx',
        method: 'post',
        data: data
    })
}

export function updateGzxx(data) {
    return request({
        url: '/wx/updateGzxx',
        method: 'post',
        data: data
    })
}

//维修器材
export function deleteWxqc(id) {
    return request({
        url: '/wx/deleteWxqc?id='+id,
        method: 'get',
        data: {}
    })
}

export function createWxqc(data) {
    return request({
        url: '/wx/createWxqc',
        method: 'post',
        data: data
    })
}

//更新维修器材
export function updateWxqc(data) {
    return request({
        url: '/wx/updateWxqc',
        method: 'post',
        data: data
    })
}